import React, { useEffect } from 'react';
import { getVar } from '@package/helpers/utils';

const CustomJS = () => {
  var customJsPath = getVar('RAZZLE_CUSTOM_JS_PATH');

  useEffect(() => {
    // Don't create script if path is undefined or empty
    if (!customJsPath) {
      return;
    }

    const script = document.createElement('script');
    script.src = customJsPath;
    script.async = true;
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, [customJsPath]);

  return <></>;
};

export default CustomJS;
